export const HELP_CATEGORIES = [
  {
    id: 'getting-started',
    titleKey: 'help_cat_getting_started',
    descriptionKey: 'help_cat_getting_started_desc',
    icon: 'rocket',
    articles: [
      {
        id: 'first-login',
        titleKey: 'help_first_login_title',
        summaryKey: 'help_first_login_summary',
        sections: [
          { headingKey: 'help_first_login_s1_heading', contentKey: 'help_first_login_s1_content' },
          { headingKey: 'help_first_login_s2_heading', contentKey: 'help_first_login_s2_content', image: '/help-screenshots/portal-sidebar.png', imageMaxWidth: 200 },
          { headingKey: 'help_first_login_s3_heading', contentKey: 'help_first_login_s3_content' },
          { headingKey: 'help_first_login_s4_heading', contentKey: 'help_first_login_s4_content' },
        ],
        tips: [
          { textKey: 'help_first_login_tip1' },
          { textKey: 'help_first_login_tip2' },
        ],
        warnings: [
          { textKey: 'help_first_login_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_first_login_q1', answerKey: 'help_first_login_a1' },
          { questionKey: 'help_first_login_q2', answerKey: 'help_first_login_a2' },
        ],
      },
      {
        id: 'business-setup-configuration',
        titleKey: 'help_business_setup_title',
        summaryKey: 'help_business_setup_summary',
        sections: [
          { headingKey: 'help_business_setup_s1_heading', contentKey: 'help_business_setup_s1_content' },
          { headingKey: 'help_business_setup_s2_heading', contentKey: 'help_business_setup_s2_content', image: '/help-screenshots/settings-business.png' },
          { headingKey: 'help_business_setup_s3_heading', contentKey: 'help_business_setup_s3_content' },
          { headingKey: 'help_business_setup_s4_heading', contentKey: 'help_business_setup_s4_content', image: '/help-screenshots/settings-dining.png' },
          { headingKey: 'help_business_setup_s5_heading', contentKey: 'help_business_setup_s5_content', image: '/help-screenshots/table-layout.png' },
        ],
        tips: [
          { textKey: 'help_business_setup_tip1' },
          { textKey: 'help_business_setup_tip2' },
        ],
        warnings: [
          { textKey: 'help_business_setup_warn1' },
          { textKey: 'help_business_setup_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_business_setup_q1', answerKey: 'help_business_setup_a1' },
          { questionKey: 'help_business_setup_q2', answerKey: 'help_business_setup_a2' },
        ],
      },
      {
        id: 'adding-first-employees',
        titleKey: 'help_add_employees_title',
        summaryKey: 'help_add_employees_summary',
        sections: [
          { headingKey: 'help_add_employees_s1_heading', contentKey: 'help_add_employees_s1_content', image: '/help-screenshots/employees-list.png' },
          { headingKey: 'help_add_employees_s2_heading', contentKey: 'help_add_employees_s2_content' },
          { headingKey: 'help_add_employees_s3_heading', contentKey: 'help_add_employees_s3_content' },
          { headingKey: 'help_add_employees_s4_heading', contentKey: 'help_add_employees_s4_content' },
        ],
        tips: [
          { textKey: 'help_add_employees_tip1' },
          { textKey: 'help_add_employees_tip2' },
        ],
        warnings: [
          { textKey: 'help_add_employees_warn1' },
          { textKey: 'help_add_employees_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_add_employees_q1', answerKey: 'help_add_employees_a1' },
          { questionKey: 'help_add_employees_q2', answerKey: 'help_add_employees_a2' },
        ],
      },
      {
        id: 'building-your-menu',
        titleKey: 'help_build_menu_title',
        summaryKey: 'help_build_menu_summary',
        sections: [
          { headingKey: 'help_build_menu_s1_heading', contentKey: 'help_build_menu_s1_content' },
          { headingKey: 'help_build_menu_s2_heading', contentKey: 'help_build_menu_s2_content' },
          { headingKey: 'help_build_menu_s3_heading', contentKey: 'help_build_menu_s3_content', image: '/help-screenshots/products-page.png' },
          { headingKey: 'help_build_menu_s4_heading', contentKey: 'help_build_menu_s4_content', image: '/help-screenshots/addon-group.png' },
          { headingKey: 'help_build_menu_s5_heading', contentKey: 'help_build_menu_s5_content' },
        ],
        tips: [
          { textKey: 'help_build_menu_tip1' },
          { textKey: 'help_build_menu_tip2' },
        ],
        warnings: [
          { textKey: 'help_build_menu_warn1' },
          { textKey: 'help_build_menu_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_build_menu_q1', answerKey: 'help_build_menu_a1' },
          { questionKey: 'help_build_menu_q2', answerKey: 'help_build_menu_a2' },
          { questionKey: 'help_build_menu_q3', answerKey: 'help_build_menu_a3' },
        ],
      },
      {
        id: 'configuring-dining-options',
        titleKey: 'help_dining_options_title',
        summaryKey: 'help_dining_options_summary',
        sections: [
          { headingKey: 'help_dining_options_s1_heading', contentKey: 'help_dining_options_s1_content' },
          { headingKey: 'help_dining_options_s2_heading', contentKey: 'help_dining_options_s2_content' },
          { headingKey: 'help_dining_options_s3_heading', contentKey: 'help_dining_options_s3_content' },
          { headingKey: 'help_dining_options_s4_heading', contentKey: 'help_dining_options_s4_content' },
        ],
        tips: [
          { textKey: 'help_dining_options_tip1' },
          { textKey: 'help_dining_options_tip2' },
        ],
        warnings: [
          { textKey: 'help_dining_options_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_dining_options_q1', answerKey: 'help_dining_options_a1' },
          { questionKey: 'help_dining_options_q2', answerKey: 'help_dining_options_a2' },
        ],
      },
    ],
  },
  {
    id: 'pos-operations',
    titleKey: 'help_cat_pos_operations',
    descriptionKey: 'help_cat_pos_operations_desc',
    icon: 'monitor',
    articles: [
      {
        id: 'taking-an-order',
        titleKey: 'help_taking_order_title',
        summaryKey: 'help_taking_order_summary',
        sections: [
          { headingKey: 'help_taking_order_s1_heading', contentKey: 'help_taking_order_s1_content' },
          { headingKey: 'help_taking_order_s2_heading', contentKey: 'help_taking_order_s2_content', image: '/help-screenshots/pos-dining-select.png' },
          { headingKey: 'help_taking_order_s3_heading', contentKey: 'help_taking_order_s3_content', image: '/help-screenshots/pos-order-items.png' },
          { headingKey: 'help_taking_order_s4_heading', contentKey: 'help_taking_order_s4_content' },
          { headingKey: 'help_taking_order_s5_heading', contentKey: 'help_taking_order_s5_content', image: '/help-screenshots/pos-payment.png' },
        ],
        tips: [
          { textKey: 'help_taking_order_tip1' },
          { textKey: 'help_taking_order_tip2' },
        ],
        warnings: [
          { textKey: 'help_taking_order_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_taking_order_q1', answerKey: 'help_taking_order_a1' },
          { questionKey: 'help_taking_order_q2', answerKey: 'help_taking_order_a2' },
        ],
      },
      {
        id: 'discounts-modifiers',
        titleKey: 'help_discounts_title',
        summaryKey: 'help_discounts_summary',
        sections: [
          { headingKey: 'help_discounts_s1_heading', contentKey: 'help_discounts_s1_content' },
          { headingKey: 'help_discounts_s2_heading', contentKey: 'help_discounts_s2_content' },
          { headingKey: 'help_discounts_s3_heading', contentKey: 'help_discounts_s3_content' },
          { headingKey: 'help_discounts_s4_heading', contentKey: 'help_discounts_s4_content' },
        ],
        tips: [
          { textKey: 'help_discounts_tip1' },
        ],
        warnings: [
          { textKey: 'help_discounts_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_discounts_q1', answerKey: 'help_discounts_a1' },
          { questionKey: 'help_discounts_q2', answerKey: 'help_discounts_a2' },
          { questionKey: 'help_discounts_q3', answerKey: 'help_discounts_a3' },
        ],
      },
      {
        id: 'split-bills-payments',
        titleKey: 'help_split_bills_title',
        summaryKey: 'help_split_bills_summary',
        sections: [
          { headingKey: 'help_split_bills_s1_heading', contentKey: 'help_split_bills_s1_content', image: '/help-screenshots/pos-split-bill.png' },
          { headingKey: 'help_split_bills_s2_heading', contentKey: 'help_split_bills_s2_content' },
          { headingKey: 'help_split_bills_s3_heading', contentKey: 'help_split_bills_s3_content' },
          { headingKey: 'help_split_bills_s4_heading', contentKey: 'help_split_bills_s4_content' },
        ],
        tips: [
          { textKey: 'help_split_bills_tip1' },
          { textKey: 'help_split_bills_tip2' },
        ],
        warnings: [
          { textKey: 'help_split_bills_warn1' },
          { textKey: 'help_split_bills_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_split_bills_q1', answerKey: 'help_split_bills_a1' },
          { questionKey: 'help_split_bills_q2', answerKey: 'help_split_bills_a2' },
        ],
      },
      {
        id: 'refunds-voids',
        titleKey: 'help_refunds_title',
        summaryKey: 'help_refunds_summary',
        sections: [
          { headingKey: 'help_refunds_s1_heading', contentKey: 'help_refunds_s1_content' },
          { headingKey: 'help_refunds_s2_heading', contentKey: 'help_refunds_s2_content' },
          { headingKey: 'help_refunds_s3_heading', contentKey: 'help_refunds_s3_content' },
          { headingKey: 'help_refunds_s4_heading', contentKey: 'help_refunds_s4_content' },
        ],
        tips: [
          { textKey: 'help_refunds_tip1' },
        ],
        warnings: [
          { textKey: 'help_refunds_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_refunds_q1', answerKey: 'help_refunds_a1' },
          { questionKey: 'help_refunds_q2', answerKey: 'help_refunds_a2' },
          { questionKey: 'help_refunds_q3', answerKey: 'help_refunds_a3' },
        ],
      },
      {
        id: 'offline-mode',
        titleKey: 'help_offline_title',
        summaryKey: 'help_offline_summary',
        sections: [
          { headingKey: 'help_offline_s1_heading', contentKey: 'help_offline_s1_content' },
          { headingKey: 'help_offline_s2_heading', contentKey: 'help_offline_s2_content' },
          { headingKey: 'help_offline_s3_heading', contentKey: 'help_offline_s3_content' },
          { headingKey: 'help_offline_s4_heading', contentKey: 'help_offline_s4_content' },
        ],
        tips: [
          { textKey: 'help_offline_tip1' },
        ],
        warnings: [
          { textKey: 'help_offline_warn1' },
          { textKey: 'help_offline_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_offline_q1', answerKey: 'help_offline_a1' },
          { questionKey: 'help_offline_q2', answerKey: 'help_offline_a2' },
          { questionKey: 'help_offline_q3', answerKey: 'help_offline_a3' },
        ],
      },
      {
        id: 'end-of-day-closeout',
        titleKey: 'help_eod_title',
        summaryKey: 'help_eod_summary',
        sections: [
          { headingKey: 'help_eod_s1_heading', contentKey: 'help_eod_s1_content' },
          { headingKey: 'help_eod_s2_heading', contentKey: 'help_eod_s2_content', image: '/help-screenshots/eod-summary.png' },
          { headingKey: 'help_eod_s3_heading', contentKey: 'help_eod_s3_content' },
          { headingKey: 'help_eod_s4_heading', contentKey: 'help_eod_s4_content' },
        ],
        tips: [
          { textKey: 'help_eod_tip1' },
          { textKey: 'help_eod_tip2' },
        ],
        warnings: [
          { textKey: 'help_eod_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_eod_q1', answerKey: 'help_eod_a1' },
          { questionKey: 'help_eod_q2', answerKey: 'help_eod_a2' },
        ],
      },
    ],
  },
  {
    id: 'managing-your-team',
    titleKey: 'help_cat_team',
    descriptionKey: 'help_cat_team_desc',
    icon: 'users',
    articles: [
      {
        id: 'employee-profiles-pins',
        titleKey: 'help_employees_title',
        summaryKey: 'help_employees_summary',
        sections: [
          { headingKey: 'help_employees_s1_heading', contentKey: 'help_employees_s1_content' },
          { headingKey: 'help_employees_s2_heading', contentKey: 'help_employees_s2_content' },
          { headingKey: 'help_employees_s3_heading', contentKey: 'help_employees_s3_content' },
          { headingKey: 'help_employees_s4_heading', contentKey: 'help_employees_s4_content' },
        ],
        tips: [
          { textKey: 'help_employees_tip1' },
        ],
        warnings: [
          { textKey: 'help_employees_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_employees_q1', answerKey: 'help_employees_a1' },
          { questionKey: 'help_employees_q2', answerKey: 'help_employees_a2' },
        ],
      },
      {
        id: 'roles-permissions',
        titleKey: 'help_roles_title',
        summaryKey: 'help_roles_summary',
        sections: [
          { headingKey: 'help_roles_s1_heading', contentKey: 'help_roles_s1_content' },
          { headingKey: 'help_roles_s2_heading', contentKey: 'help_roles_s2_content', image: '/help-screenshots/roles-permissions.png' },
          { headingKey: 'help_roles_s3_heading', contentKey: 'help_roles_s3_content' },
        ],
        tips: [
          { textKey: 'help_roles_tip1' },
        ],
        warnings: [
          { textKey: 'help_roles_warn1' },
          { textKey: 'help_roles_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_roles_q1', answerKey: 'help_roles_a1' },
          { questionKey: 'help_roles_q2', answerKey: 'help_roles_a2' },
        ],
      },
      {
        id: 'scheduling-shifts',
        titleKey: 'help_schedule_title',
        summaryKey: 'help_schedule_summary',
        sections: [
          { headingKey: 'help_schedule_s1_heading', contentKey: 'help_schedule_s1_content', image: '/help-screenshots/schedule-week.png' },
          { headingKey: 'help_schedule_s2_heading', contentKey: 'help_schedule_s2_content' },
          { headingKey: 'help_schedule_s3_heading', contentKey: 'help_schedule_s3_content' },
          { headingKey: 'help_schedule_s4_heading', contentKey: 'help_schedule_s4_content' },
          { headingKey: 'help_schedule_s5_heading', contentKey: 'help_schedule_s5_content' },
        ],
        tips: [
          { textKey: 'help_schedule_tip1' },
          { textKey: 'help_schedule_tip2' },
        ],
        warnings: [
          { textKey: 'help_schedule_warn1' },
          { textKey: 'help_schedule_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_schedule_q1', answerKey: 'help_schedule_a1' },
          { questionKey: 'help_schedule_q2', answerKey: 'help_schedule_a2' },
          { questionKey: 'help_schedule_q3', answerKey: 'help_schedule_a3' },
        ],
      },
      {
        id: 'payroll-advances',
        titleKey: 'help_payroll_title',
        summaryKey: 'help_payroll_summary',
        sections: [
          { headingKey: 'help_payroll_s1_heading', contentKey: 'help_payroll_s1_content', image: '/help-screenshots/payroll-summary.png' },
          { headingKey: 'help_payroll_s2_heading', contentKey: 'help_payroll_s2_content' },
          { headingKey: 'help_payroll_s3_heading', contentKey: 'help_payroll_s3_content' },
          { headingKey: 'help_payroll_s4_heading', contentKey: 'help_payroll_s4_content' },
          { headingKey: 'help_payroll_s5_heading', contentKey: 'help_payroll_s5_content' },
        ],
        tips: [
          { textKey: 'help_payroll_tip1' },
          { textKey: 'help_payroll_tip2' },
        ],
        warnings: [
          { textKey: 'help_payroll_warn1' },
          { textKey: 'help_payroll_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_payroll_q1', answerKey: 'help_payroll_a1' },
          { questionKey: 'help_payroll_q2', answerKey: 'help_payroll_a2' },
          { questionKey: 'help_payroll_q3', answerKey: 'help_payroll_a3' },
        ],
      },
    ],
  },
  {
    id: 'products-inventory',
    titleKey: 'help_cat_products',
    descriptionKey: 'help_cat_products_desc',
    icon: 'package',
    articles: [
      {
        id: 'menu-categories',
        titleKey: 'help_menu_title',
        summaryKey: 'help_menu_summary',
        sections: [
          { headingKey: 'help_menu_s1_heading', contentKey: 'help_menu_s1_content' },
          { headingKey: 'help_menu_s2_heading', contentKey: 'help_menu_s2_content' },
          { headingKey: 'help_menu_s3_heading', contentKey: 'help_menu_s3_content' },
          { headingKey: 'help_menu_s4_heading', contentKey: 'help_menu_s4_content' },
        ],
        tips: [
          { textKey: 'help_menu_tip1' },
          { textKey: 'help_menu_tip2' },
        ],
        warnings: [
          { textKey: 'help_menu_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_menu_q1', answerKey: 'help_menu_a1' },
          { questionKey: 'help_menu_q2', answerKey: 'help_menu_a2' },
        ],
      },
      {
        id: 'addons-modifiers',
        titleKey: 'help_addons_title',
        summaryKey: 'help_addons_summary',
        sections: [
          { headingKey: 'help_addons_s1_heading', contentKey: 'help_addons_s1_content' },
          { headingKey: 'help_addons_s2_heading', contentKey: 'help_addons_s2_content' },
          { headingKey: 'help_addons_s3_heading', contentKey: 'help_addons_s3_content' },
          { headingKey: 'help_addons_s4_heading', contentKey: 'help_addons_s4_content' },
        ],
        tips: [
          { textKey: 'help_addons_tip1' },
        ],
        warnings: [
          { textKey: 'help_addons_warn1' },
          { textKey: 'help_addons_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_addons_q1', answerKey: 'help_addons_a1' },
          { questionKey: 'help_addons_q2', answerKey: 'help_addons_a2' },
        ],
      },
      {
        id: 'ingredients-recipes',
        titleKey: 'help_ingredients_title',
        summaryKey: 'help_ingredients_summary',
        sections: [
          { headingKey: 'help_ingredients_s1_heading', contentKey: 'help_ingredients_s1_content' },
          { headingKey: 'help_ingredients_s2_heading', contentKey: 'help_ingredients_s2_content', image: '/help-screenshots/recipe-editor.png' },
          { headingKey: 'help_ingredients_s3_heading', contentKey: 'help_ingredients_s3_content' },
          { headingKey: 'help_ingredients_s4_heading', contentKey: 'help_ingredients_s4_content' },
        ],
        tips: [
          { textKey: 'help_ingredients_tip1' },
          { textKey: 'help_ingredients_tip2' },
        ],
        warnings: [
          { textKey: 'help_ingredients_warn1' },
          { textKey: 'help_ingredients_warn2' },
        ],
        scenarios: [
          { questionKey: 'help_ingredients_q1', answerKey: 'help_ingredients_a1' },
          { questionKey: 'help_ingredients_q2', answerKey: 'help_ingredients_a2' },
        ],
      },
      {
        id: 'stock-tracking',
        titleKey: 'help_stock_title',
        summaryKey: 'help_stock_summary',
        sections: [
          { headingKey: 'help_stock_s1_heading', contentKey: 'help_stock_s1_content', image: '/help-screenshots/inventory-list.png' },
          { headingKey: 'help_stock_s2_heading', contentKey: 'help_stock_s2_content' },
          { headingKey: 'help_stock_s3_heading', contentKey: 'help_stock_s3_content' },
          { headingKey: 'help_stock_s4_heading', contentKey: 'help_stock_s4_content' },
        ],
        tips: [
          { textKey: 'help_stock_tip1' },
          { textKey: 'help_stock_tip2' },
        ],
        warnings: [
          { textKey: 'help_stock_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_stock_q1', answerKey: 'help_stock_a1' },
          { questionKey: 'help_stock_q2', answerKey: 'help_stock_a2' },
        ],
      },
    ],
  },
  {
    id: 'daily-finance',
    titleKey: 'help_cat_finance',
    descriptionKey: 'help_cat_finance_desc',
    icon: 'wallet',
    articles: [
      {
        id: 'recording-expenses',
        titleKey: 'help_expenses_title',
        summaryKey: 'help_expenses_summary',
        sections: [
          { headingKey: 'help_expenses_s1_heading', contentKey: 'help_expenses_s1_content' },
          { headingKey: 'help_expenses_s2_heading', contentKey: 'help_expenses_s2_content', image: '/help-screenshots/expenses-page.png' },
          { headingKey: 'help_expenses_s3_heading', contentKey: 'help_expenses_s3_content' },
          { headingKey: 'help_expenses_s4_heading', contentKey: 'help_expenses_s4_content' },
        ],
        tips: [
          { textKey: 'help_expenses_tip1' },
          { textKey: 'help_expenses_tip2' },
        ],
        warnings: [
          { textKey: 'help_expenses_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_expenses_q1', answerKey: 'help_expenses_a1' },
          { questionKey: 'help_expenses_q2', answerKey: 'help_expenses_a2' },
        ],
      },
      {
        id: 'overhead-vs-daily',
        titleKey: 'help_overhead_title',
        summaryKey: 'help_overhead_summary',
        sections: [
          { headingKey: 'help_overhead_s1_heading', contentKey: 'help_overhead_s1_content' },
          { headingKey: 'help_overhead_s2_heading', contentKey: 'help_overhead_s2_content' },
          { headingKey: 'help_overhead_s3_heading', contentKey: 'help_overhead_s3_content' },
        ],
        tips: [
          { textKey: 'help_overhead_tip1' },
        ],
        warnings: [
          { textKey: 'help_overhead_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_overhead_q1', answerKey: 'help_overhead_a1' },
          { questionKey: 'help_overhead_q2', answerKey: 'help_overhead_a2' },
          { questionKey: 'help_overhead_q3', answerKey: 'help_overhead_a3' },
        ],
      },
      {
        id: 'cash-management',
        titleKey: 'help_cash_title',
        summaryKey: 'help_cash_summary',
        sections: [
          { headingKey: 'help_cash_s1_heading', contentKey: 'help_cash_s1_content' },
          { headingKey: 'help_cash_s2_heading', contentKey: 'help_cash_s2_content' },
          { headingKey: 'help_cash_s3_heading', contentKey: 'help_cash_s3_content' },
          { headingKey: 'help_cash_s4_heading', contentKey: 'help_cash_s4_content' },
        ],
        tips: [
          { textKey: 'help_cash_tip1' },
          { textKey: 'help_cash_tip2' },
        ],
        warnings: [
          { textKey: 'help_cash_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_cash_q1', answerKey: 'help_cash_a1' },
          { questionKey: 'help_cash_q2', answerKey: 'help_cash_a2' },
        ],
      },
    ],
  },
  {
    id: 'reports-analytics',
    titleKey: 'help_cat_reports',
    descriptionKey: 'help_cat_reports_desc',
    icon: 'chart',
    articles: [
      {
        id: 'understanding-your-dashboard',
        titleKey: 'help_dashboard_title',
        summaryKey: 'help_dashboard_summary',
        sections: [
          { headingKey: 'help_dashboard_s1_heading', contentKey: 'help_dashboard_s1_content', image: '/help-screenshots/dashboard-overview.png' },
          { headingKey: 'help_dashboard_s2_heading', contentKey: 'help_dashboard_s2_content' },
          { headingKey: 'help_dashboard_s3_heading', contentKey: 'help_dashboard_s3_content' },
        ],
        tips: [
          { textKey: 'help_dashboard_tip1' },
        ],
        warnings: [
          { textKey: 'help_dashboard_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_dashboard_q1', answerKey: 'help_dashboard_a1' },
          { questionKey: 'help_dashboard_q2', answerKey: 'help_dashboard_a2' },
        ],
      },
      {
        id: 'kpis-explained',
        titleKey: 'help_kpis_title',
        summaryKey: 'help_kpis_summary',
        sections: [
          { headingKey: 'help_kpis_s1_heading', contentKey: 'help_kpis_s1_content', image: '/help-screenshots/analytics-financial.png' },
          { headingKey: 'help_kpis_s2_heading', contentKey: 'help_kpis_s2_content' },
          { headingKey: 'help_kpis_s3_heading', contentKey: 'help_kpis_s3_content' },
          { headingKey: 'help_kpis_s4_heading', contentKey: 'help_kpis_s4_content' },
          { headingKey: 'help_kpis_s5_heading', contentKey: 'help_kpis_s5_content' },
          { headingKey: 'help_kpis_s6_heading', contentKey: 'help_kpis_s6_content' },
        ],
        tips: [
          { textKey: 'help_kpis_tip1' },
        ],
        warnings: [
          { textKey: 'help_kpis_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_kpis_q1', answerKey: 'help_kpis_a1' },
          { questionKey: 'help_kpis_q2', answerKey: 'help_kpis_a2' },
        ],
      },
      {
        id: 'product-performance',
        titleKey: 'help_product_perf_title',
        summaryKey: 'help_product_perf_summary',
        sections: [
          { headingKey: 'help_product_perf_s1_heading', contentKey: 'help_product_perf_s1_content', image: '/help-screenshots/analytics-product.png' },
          { headingKey: 'help_product_perf_s2_heading', contentKey: 'help_product_perf_s2_content' },
          { headingKey: 'help_product_perf_s3_heading', contentKey: 'help_product_perf_s3_content' },
          { headingKey: 'help_product_perf_s4_heading', contentKey: 'help_product_perf_s4_content' },
        ],
        tips: [
          { textKey: 'help_product_perf_tip1' },
        ],
        warnings: [
          { textKey: 'help_product_perf_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_product_perf_q1', answerKey: 'help_product_perf_a1' },
          { questionKey: 'help_product_perf_q2', answerKey: 'help_product_perf_a2' },
        ],
      },
      {
        id: 'staff-performance',
        titleKey: 'help_staff_perf_title',
        summaryKey: 'help_staff_perf_summary',
        sections: [
          { headingKey: 'help_staff_perf_s1_heading', contentKey: 'help_staff_perf_s1_content' },
          { headingKey: 'help_staff_perf_s2_heading', contentKey: 'help_staff_perf_s2_content' },
          { headingKey: 'help_staff_perf_s3_heading', contentKey: 'help_staff_perf_s3_content' },
        ],
        tips: [
          { textKey: 'help_staff_perf_tip1' },
        ],
        warnings: [
          { textKey: 'help_staff_perf_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_staff_perf_q1', answerKey: 'help_staff_perf_a1' },
          { questionKey: 'help_staff_perf_q2', answerKey: 'help_staff_perf_a2' },
        ],
      },
      {
        id: 'peak-hours',
        titleKey: 'help_peak_hours_title',
        summaryKey: 'help_peak_hours_summary',
        sections: [
          { headingKey: 'help_peak_hours_s1_heading', contentKey: 'help_peak_hours_s1_content' },
          { headingKey: 'help_peak_hours_s2_heading', contentKey: 'help_peak_hours_s2_content' },
          { headingKey: 'help_peak_hours_s3_heading', contentKey: 'help_peak_hours_s3_content' },
        ],
        tips: [
          { textKey: 'help_peak_hours_tip1' },
        ],
        warnings: [
          { textKey: 'help_peak_hours_warn1' },
        ],
        scenarios: [
          { questionKey: 'help_peak_hours_q1', answerKey: 'help_peak_hours_a1' },
          { questionKey: 'help_peak_hours_q2', answerKey: 'help_peak_hours_a2' },
        ],
      },
    ],
  },
  {
    id: 'reservations-floor',
    titleKey: 'help_cat_reservations',
    descriptionKey: 'help_cat_reservations_desc',
    icon: 'calendar',
    articles: [
      {
        id: 'managing-reservations',
        titleKey: 'help_reservations_title',
        summaryKey: 'help_reservations_summary',
        sections: [
          { headingKey: 'help_reservations_s1_heading', contentKey: 'help_reservations_s1_content' },
          { headingKey: 'help_reservations_s2_heading', contentKey: 'help_reservations_s2_content' },
          { headingKey: 'help_reservations_s3_heading', contentKey: 'help_reservations_s3_content' },
        ],
        tips: [{ textKey: 'help_reservations_tip1' }],
        warnings: [{ textKey: 'help_reservations_warn1' }],
        scenarios: [
          { questionKey: 'help_reservations_q1', answerKey: 'help_reservations_a1' },
        ],
      },
      {
        id: 'waiting-list',
        titleKey: 'help_waitlist_title',
        summaryKey: 'help_waitlist_summary',
        sections: [
          { headingKey: 'help_waitlist_s1_heading', contentKey: 'help_waitlist_s1_content' },
          { headingKey: 'help_waitlist_s2_heading', contentKey: 'help_waitlist_s2_content' },
        ],
        tips: [{ textKey: 'help_waitlist_tip1' }],
        warnings: [],
        scenarios: [
          { questionKey: 'help_waitlist_q1', answerKey: 'help_waitlist_a1' },
        ],
      },
      {
        id: 'table-occupation-floor-plan',
        titleKey: 'help_occupation_title',
        summaryKey: 'help_occupation_summary',
        sections: [
          { headingKey: 'help_occupation_s1_heading', contentKey: 'help_occupation_s1_content' },
          { headingKey: 'help_occupation_s2_heading', contentKey: 'help_occupation_s2_content' },
          { headingKey: 'help_occupation_s3_heading', contentKey: 'help_occupation_s3_content' },
        ],
        tips: [{ textKey: 'help_occupation_tip1' }],
        warnings: [{ textKey: 'help_occupation_warn1' }],
        scenarios: [],
      },
      {
        id: 'table-service-mode',
        titleKey: 'help_table_service_title',
        summaryKey: 'help_table_service_summary',
        sections: [
          { headingKey: 'help_table_service_s1_heading', contentKey: 'help_table_service_s1_content' },
          { headingKey: 'help_table_service_s2_heading', contentKey: 'help_table_service_s2_content' },
          { headingKey: 'help_table_service_s3_heading', contentKey: 'help_table_service_s3_content' },
        ],
        tips: [{ textKey: 'help_table_service_tip1' }],
        warnings: [],
        scenarios: [
          { questionKey: 'help_table_service_q1', answerKey: 'help_table_service_a1' },
        ],
      },
    ],
  },
];

export const HELP_PAGE_MAPPING = {
  overview: 'understanding-your-dashboard',
  employees: 'employee-profiles-pins',
  payroll: 'payroll-advances',
  schedule: 'scheduling-shifts',
  products: 'menu-categories',
  inventory: 'ingredients-recipes',
  expenses: 'recording-expenses',
  settings: 'business-setup-configuration',
  reporting: 'understanding-your-dashboard',
};

export function findArticleById(articleId) {
  for (const cat of HELP_CATEGORIES) {
    const article = cat.articles.find(a => a.id === articleId);
    if (article) return { category: cat, article };
  }
  return null;
}

export function searchArticles(query, t) {
  if (!query || query.length < 2) return [];
  const lower = query.toLowerCase();
  const results = [];
  for (const cat of HELP_CATEGORIES) {
    for (const article of cat.articles) {
      const title = t(article.titleKey).toLowerCase();
      const summary = t(article.summaryKey).toLowerCase();
      if (title.includes(lower) || summary.includes(lower)) {
        results.push({ category: cat, article });
        continue;
      }
      const sectionMatch = article.sections.some(s =>
        t(s.headingKey).toLowerCase().includes(lower) ||
        t(s.contentKey).toLowerCase().includes(lower)
      );
      if (sectionMatch) {
        results.push({ category: cat, article });
        continue;
      }
      const scenarioMatch = article.scenarios.some(s =>
        t(s.questionKey).toLowerCase().includes(lower) ||
        t(s.answerKey).toLowerCase().includes(lower)
      );
      if (scenarioMatch) {
        results.push({ category: cat, article });
      }
    }
  }
  return results;
}
